import React from 'react';

export default function NotFound() {
  return (
    <div className='d-flex justify-content-center m5'>
      <h1>🛠Page Not Found🛠</h1>
    </div>
  );
}
